import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=b8cdd2cc&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=b8cdd2cc&prod&lang=scss"
import style1 from "./edit.vue?vue&type=style&index=1&id=b8cdd2cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cdd2cc",
  null
  
)

export default component.exports